import { useContext, useEffect, useState } from "react";
import { formatDateToDDMMAAAA } from "../../../../../functions/kit-mdtw/dates";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SeleccionContext from "../../../../../context/Seleccion/SeleccionContext";
import ActionMassive from "./ActionMassive";
import { ICandidatoSolRecibida } from "../../../../../interfaces/ISeleccion";
import IconCheck from "../../../../ui/icons-seleccion/IconCheck";
import IconCancel from "../../../../ui/icons-seleccion/IconCancel";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import ModalAceptarRegistro from "../Modal/ModalAceptarRegistro";
import ModalRechazarRegistro from "../Modal/ModalRechazarRegistro";
import FooterTablePagination from "../../../../ui/kit-mdtw/table/FooterTablePagination";
import Tooltip from "../../../../ui/kit-mdtw/tooltip/Tooltip";
import TableSkeleton from "../../../../ui/kit-mdtw/table/TableSkeleton";
import CircularProgress from "@mui/material/CircularProgress";
import { AnimatePresence } from "framer-motion";
import ModalVerSolicitud from "../SolicitudEnviada/ModalVerSolicitud";

const TablaSolicitudRecibida = () => {
  const {
    listaCandidatoSolRecibida,
    getCandidatoPreSolRecibida,
    putResponderSolTraspaso,
    getDetalleSolicitudTraspaso,
    token,
    getToken,
  } = useContext(SeleccionContext);
  const [isLoadingTable, setIsLoadingTable] = useState<boolean | undefined>(
    undefined
  );
  const [isErrorTable, setIsErrorTable] = useState<boolean | undefined>(
    undefined
  );
  const [listadoSeleccionado, setListadoSeleccionado] = useState<string[]>([]);
  const [candidateSelect, setCandidateSelect] = useState<any[]>([]);
  const [currentCandidates, setCurrentCandidates] = useState<string[]>([]);
  const [isOpenModalAceptarRegistro, setIsOpenModalAceptarRegistro] =
    useState<boolean>(false);
  const [isOpenModalRechazarRegistro, setIsOpenModalRechazarRegistro] =
    useState<boolean>(false);
  const [solicitudes, setSolicitudes] = useState<any>([]);
  const [openModalVerSolicitud, setOpenModalVerSolicitud] = useState<boolean>(false);
  const [detalleData, setDetalleData] = useState<any>(null);
  const [loadingVerSolicitud, setLoadingVerSolicitud] = useState<string | null>(null);
  const [currentViewingSolicitudId, setCurrentViewingSolicitudId] = useState<string | null>(null);
  const [gridCandidatoSolRecibida, setGridCandidatoSolRecibida] = useState<
    any[]
  >([]);
  const [offset, setOffset] = useState<any>({
    offset: { value: undefined, valid: true },
    pages: 1,
  });
  const [paginationData, setPaginationData] = useState<any>({});
  const [localStorageFilter, setLocalStorageFilter] = useState<string>(
    "filtroCandidatoSolRecibida"
  );
  const [formFilter, setFormFilter] = useState<any>({
    nombre: [],
    rut: [],
    proceso: [],
    procesoDestino: [],
    solicitante: [],
    fechaSolicitud: [],
  });

  useEffect(() => {
    if (token) {
      if (localStorage.getItem(localStorageFilter)) {
        const copyStorage: any = localStorage.getItem(localStorageFilter);
        getCandidatoPreSolRecibida({
          token,
          filtros: JSON.parse(copyStorage),
          setIsErrorTable,
          setIsLoadingTable,
          setPaginationData,
          page: offset.pages ?? 1,
          limit: offset.offset.value?.code ?? 10,
        });
      } else {
        getCandidatoPreSolRecibida({
          token,
          filtros: formFilter,
          setIsErrorTable,
          setIsLoadingTable,
          setPaginationData,
          page: offset.pages ?? 1,
          limit: offset.offset.value?.code ?? 10,
        });
      }
    }
  }, [token, localStorage.getItem(localStorageFilter), offset.pages, offset.offset]);

  useEffect(() => {
    if (listaCandidatoSolRecibida) {
      const arrayList = listaCandidatoSolRecibida
        .filter((item: ICandidatoSolRecibida) => item.estado !== "APROBADA" && item.estado !== "RECHAZADA")
        .map((item: ICandidatoSolRecibida) => item.personaDNI+'-'+item.solicitudTraspasoId);
      setCurrentCandidates(arrayList);
    }
  }, [listaCandidatoSolRecibida]);

  useEffect(() => {
    if (listaCandidatoSolRecibida) {
      setGridCandidatoSolRecibida([...listaCandidatoSolRecibida]);
    }
  }, [listaCandidatoSolRecibida]);

  const handleClickAddOrRemoveChoise = (prompts: any): void => {
    const { personaDNI, solicitudTraspasoId } = prompts;
    const arrayList: string[] = [...listadoSeleccionado];

    if (!arrayList.includes(personaDNI+'-'+solicitudTraspasoId)) {
      arrayList.push(personaDNI+'-'+solicitudTraspasoId);
    } else {
      const position: number = arrayList.findIndex(
        (item: string) => item === personaDNI+'-'+solicitudTraspasoId
      );
      arrayList.splice(position, 1);
    }
    setListadoSeleccionado(arrayList);
  };

  const handleClickAddAll = (): void => {
    if (listadoSeleccionado.length < currentCandidates.length) {
      const missing = currentCandidates.filter(
        (item: string) => !listadoSeleccionado.includes(item)
      );
      setListadoSeleccionado([...listadoSeleccionado, ...missing]);
    } else {
      setListadoSeleccionado([]);
    }
  };

  const handleClickVerSolicitud = async (rowData: any): Promise<void> => {
    const { solicitudTraspasoId } = rowData;
    setLoadingVerSolicitud(solicitudTraspasoId);
    const data = await getDetalleSolicitudTraspaso({
      token,
      transferRequestId: solicitudTraspasoId,
      setIsLoading: (val: boolean) => {
        if (!val) setLoadingVerSolicitud(null);
      },
    });
    if (data) {
      setCurrentViewingSolicitudId(solicitudTraspasoId);
      setDetalleData(data);
      setOpenModalVerSolicitud(true);
    }
  };

  const handleResponderDesdeDetalle = async ({ aceptar, comentario }: { aceptar: boolean; comentario: string }): Promise<void> => {
    if (!token || !currentViewingSolicitudId) return;
    const solicitudesParam = [{ solicitudTraspasoId: currentViewingSolicitudId, aceptar, comentario }];
    await putResponderSolTraspaso({ token, solicitudes: solicitudesParam, status: aceptar });
    await getCandidatoPreSolRecibida({ token, filtros: formFilter, setIsErrorTable, setIsLoadingTable, setPaginationData, page: offset.pages ?? 1, limit: offset.offset.value?.code ?? 10 });
    setOpenModalVerSolicitud(false);
    setDetalleData(null);
    setCurrentViewingSolicitudId(null);
  };

  const handleClickAcceptRegister = (values: any): void => {
    const { personaDNI, solicitudTraspasoId } = values;
    setIsOpenModalAceptarRegistro(true);
    setCandidateSelect([personaDNI+'-'+solicitudTraspasoId]);
  };

  const handleClickDeclineRegister = (values: any): void => {
    const { personaDNI, solicitudTraspasoId } = values;
    setIsOpenModalRechazarRegistro(true);
    setCandidateSelect([personaDNI+'-'+solicitudTraspasoId]);
  };

  const handleClickSolResponse = async (values: any): Promise<void> => {
    const { status } = values;
    if (token) {
      await putResponderSolTraspaso({ token, solicitudes, status });
      await getCandidatoPreSolRecibida({
        token,
        filtros: formFilter,
        setIsErrorTable,
        setIsLoadingTable,
        setPaginationData,
        page: offset.pages ?? 1,
        limit: offset.offset.value?.code ?? 10,
      });
    }
  };

  return (
    <>
      <section className="content-seleccion-multiple action-in-line margin-top-20">
        <div className="content-multiple">
          <label className="title-multiple">
            <span
              className={`selects-badge${listadoSeleccionado.length === 0 ? " inactive" : ""}`}
              style={{ transition: "background 0.3s ease, color 0.3s ease, font-weight 0.3s ease" }}
            >
              {listadoSeleccionado.length > 0
                ? `${listadoSeleccionado.length} ítem${listadoSeleccionado.length !== 1 ? "s" : ""} seleccionado${listadoSeleccionado.length !== 1 ? "s" : ""}`
                : "0 ítems seleccionados"}
            </span>
          </label>
        </div>
        <ActionMassive
          listadoSeleccionado={listadoSeleccionado}
          localStorageFilter={localStorageFilter}
          formFilter={formFilter}
          setFormFilter={setFormFilter}
          handleClickSolResponse={handleClickSolResponse}
          solicitudes={solicitudes}
          setSolicitudes={setSolicitudes}
        />
      </section>

      <section className="content-header-table" style={{ justifyContent: "center", background: "#065f46" }}>
        <label className="title-header-table" style={{ textTransform: "uppercase", gap: "8px" }}>
          <MoveToInboxIcon sx={{ fontSize: 18 }} />
          Solicitudes Recibidas
        </label>
      </section>

      {!isLoadingTable ? (
        <>
          {isErrorTable ? (
            <div className="container-is-error-table">
              Error al cargar los datos.
            </div>
          ) : (
            <>
              <main className="container-table-list traspaso-table-container">
                <table className="content-table traspaso-table-recibida">
                  <thead className="thead-table-registros">
                    <tr>
                      <th className="th-table-registros col-w-check">
                        <button
                          onClick={handleClickAddAll}
                          className="button-select"
                        >
                          {listadoSeleccionado.length ==
                            currentCandidates.length &&
                          listadoSeleccionado.length > 0 ? (
                            <CheckBoxIcon />
                          ) : (
                            <CheckBoxOutlineBlankIcon />
                          )}
                        </button>
                      </th>
                      <th className="th-table-registros">Nombre</th>
                      <th className="th-table-registros col-w-rut">Rut</th>
                      <th className="th-table-registros">ID Origen</th>
                      <th className="th-table-registros">ID Destino</th>
                      <th className="th-table-registros">Solicitante</th>
                      <th className="th-table-registros col-w-fecha">Fecha Solicitud</th>
                      <th className="th-table-registros">Estado</th>
                      <th className="th-table-registros col-w-acciones">Acciones</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-table-registros">
                    {gridCandidatoSolRecibida &&
                      gridCandidatoSolRecibida.map(
                        (item: ICandidatoSolRecibida) => {
                          const {
                            personaDNI,
                            estado,
                            primerNombre,
                            primerApellido,
                            procesoOrigen,
                            procesoDestino,
                            fechaSolicitud,
                            solicitante,
                            solicitudTraspasoId,
                          } = item;
                          const estadoDisplay = estado === "ENVIADA" ? "RECIBIDA" : estado;
                          return (
                            <>
                              <tr
                                key={personaDNI}
                                className={`tr-table-registros${
                                  listadoSeleccionado.includes(personaDNI+'-'+solicitudTraspasoId)
                                    ? " checkeado"
                                    : ""
                                }${estadoDisplay === "APROBADA" ? " estado-aprobada" : estadoDisplay === "RECHAZADA" ? " estado-rechazada" : ""}`}
                                style={{
                                  backgroundColor:
                                    estadoDisplay === "APROBADA"
                                      ? "#DCFCE7"
                                      : estadoDisplay === "RECHAZADA"
                                      ? "#FFF1F2"
                                      : undefined,
                                }}
                                onMouseEnter={(e) => {
                                  if (estadoDisplay === "APROBADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#BBF7D0";
                                  else if (estadoDisplay === "RECHAZADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#FFE4E6";
                                }}
                                onMouseLeave={(e) => {
                                  if (estadoDisplay === "APROBADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#DCFCE7";
                                  else if (estadoDisplay === "RECHAZADA")
                                    (e.currentTarget as HTMLTableRowElement).style.backgroundColor = "#FFF1F2";
                                }}
                              >
                                <td className="td-table-registros col-w-check">
                                  {estadoDisplay !== "APROBADA" && estadoDisplay !== "RECHAZADA" && (
                                    <button
                                      className="button-select"
                                      onClick={() =>
                                        handleClickAddOrRemoveChoise({
                                          personaDNI,
                                          solicitudTraspasoId,
                                        })
                                      }
                                    >
                                      {listadoSeleccionado.includes(
                                        personaDNI+'-'+solicitudTraspasoId
                                      ) ? (
                                        <CheckBoxIcon />
                                      ) : (
                                        <CheckBoxOutlineBlankIcon />
                                      )}
                                    </button>
                                  )}
                                </td>
                                <td className="td-table-registros" data-label="Nombre">
                                  {primerNombre} {primerApellido}
                                </td>
                                <td className="td-table-registros col-w-rut" data-label="Rut">
                                  {personaDNI}
                                </td>
                                <td className="td-table-registros" data-label="ID Origen">
                                  <span style={{
                                    display: "inline-block",
                                    backgroundColor: "#DBEAFE",
                                    color: "#1D4ED8",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    padding: "2px 8px",
                                    borderRadius: "6px",
                                    border: "1px solid #93C5FD",
                                  }}>
                                    {procesoOrigen}
                                  </span>
                                </td>
                                <td className="td-table-registros" data-label="ID Destino">
                                  {procesoDestino}
                                </td>
                                <td className="td-table-registros" data-label="Solicitante">
                                  {solicitante}
                                </td>
                                <td className="td-table-registros col-w-fecha" data-label="Fecha">
                                  {formatDateToDDMMAAAA({
                                    date: fechaSolicitud,
                                    format: "/",
                                  })}
                                </td>
                                <td className="td-table-registros" data-label="Estado">
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "6px",
                                      width: "110px",
                                      padding: "5px 0",
                                      borderRadius: "20px",
                                      fontSize: "11px",
                                      fontWeight: 700,
                                      letterSpacing: "0.5px",
                                      textTransform: "uppercase",
                                      backgroundColor:
                                        estadoDisplay === "RECIBIDA"
                                          ? "#FFF7ED"
                                          : estadoDisplay === "APROBADA"
                                          ? "#DCFCE7"
                                          : estadoDisplay === "RECHAZADA"
                                          ? "#FFE4E6"
                                          : "#F3F4F6",
                                      color:
                                        estadoDisplay === "RECIBIDA"
                                          ? "#C2410C"
                                          : estadoDisplay === "APROBADA"
                                          ? "#15803D"
                                          : estadoDisplay === "RECHAZADA"
                                          ? "#BE123C"
                                          : "#6B7280",
                                      border: "1px solid",
                                      borderColor:
                                        estadoDisplay === "RECIBIDA"
                                          ? "#FDBA74"
                                          : estadoDisplay === "APROBADA"
                                          ? "#86EFAC"
                                          : estadoDisplay === "RECHAZADA"
                                          ? "#FCA5A5"
                                          : "#D1D5DB",
                                    }}
                                  >
                                    {estadoDisplay === "RECIBIDA" && (
                                      <MoveToInboxIcon sx={{ fontSize: 12 }} />
                                    )}
                                    {estadoDisplay === "APROBADA" && (
                                      <TaskAltIcon sx={{ fontSize: 12 }} />
                                    )}
                                    {estadoDisplay === "RECHAZADA" && (
                                      <CancelIcon sx={{ fontSize: 12 }} />
                                    )}
                                    {estadoDisplay}
                                  </span>
                                </td>
                                <td className="td-table-registros col-w-acciones">
                                  <section className="content-icon-table">
                                    <Tooltip text="Ver solicitud">
                                      <button
                                        onClick={() => handleClickVerSolicitud(item)}
                                        className="button-content"
                                        disabled={loadingVerSolicitud === solicitudTraspasoId}
                                      >
                                        {loadingVerSolicitud === solicitudTraspasoId ? (
                                          <CircularProgress size={18} thickness={4} sx={{ color: "#0065DD" }} />
                                        ) : (
                                          <VisibilityIcon sx={{ fontSize: 20, color: "#0065DD" }} />
                                        )}
                                      </button>
                                    </Tooltip>
                                    {estadoDisplay !== "APROBADA" && estadoDisplay !== "RECHAZADA" && (
                                      <>
                                        <Tooltip text="Aprobar Solicitud">
                                          <button
                                            onClick={() =>
                                              handleClickAcceptRegister({
                                                personaDNI,
                                                solicitudTraspasoId,
                                              })
                                            }
                                            className="button-content"
                                          >
                                            <IconCheck fill={"#06A502"} />
                                          </button>
                                        </Tooltip>
                                        <Tooltip text="Rechazar Solicitud">
                                          <button
                                            onClick={() =>
                                              handleClickDeclineRegister({
                                                personaDNI,
                                                solicitudTraspasoId,
                                              })
                                            }
                                            className="button-content"
                                          >
                                            <IconCancel fill={"#FF4900"} />
                                          </button>
                                        </Tooltip>
                                      </>
                                    )}
                                  </section>
                                </td>
                              </tr>
                            </>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </main>

              {/* Tarjetas mobile */}
              <div className="traspaso-cards-mobile">
                {gridCandidatoSolRecibida && gridCandidatoSolRecibida.map((item: ICandidatoSolRecibida) => {
                  const { personaDNI, estado, primerNombre, primerApellido, procesoOrigen, procesoDestino, fechaSolicitud, solicitante, solicitudTraspasoId } = item as any;
                  const estadoDisplay = estado === "ENVIADA" ? "RECIBIDA" : estado;
                  const isSeleccionado = listadoSeleccionado.includes(personaDNI + '-' + solicitudTraspasoId);
                  const isPendiente = estadoDisplay !== "APROBADA" && estadoDisplay !== "RECHAZADA";
                  return (
                    <div
                      key={solicitudTraspasoId}
                      className={`traspaso-card${estadoDisplay === "APROBADA" ? " estado-aprobada" : estadoDisplay === "RECHAZADA" ? " estado-rechazada" : isSeleccionado ? " estado-seleccionado" : ""}`}
                    >
                      <div className="traspaso-card-header">
                        {isPendiente && (
                          <button
                            className="button-select"
                            style={{ flexShrink: 0 }}
                            onClick={() => handleClickAddOrRemoveChoise({ personaDNI, solicitudTraspasoId })}
                          >
                            {isSeleccionado ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                          </button>
                        )}
                        <span className="traspaso-card-name">{primerNombre} {primerApellido}</span>
                        <span style={{
                          display: "inline-flex", alignItems: "center", gap: "5px",
                          padding: "3px 10px", borderRadius: "20px", fontSize: "10px",
                          fontWeight: 700, letterSpacing: "0.5px", textTransform: "uppercase" as const,
                          whiteSpace: "nowrap" as const,
                          backgroundColor: estadoDisplay === "RECIBIDA" ? "#FFF7ED" : estadoDisplay === "APROBADA" ? "#DCFCE7" : estadoDisplay === "RECHAZADA" ? "#FFE4E6" : "#F3F4F6",
                          color: estadoDisplay === "RECIBIDA" ? "#C2410C" : estadoDisplay === "APROBADA" ? "#15803D" : estadoDisplay === "RECHAZADA" ? "#BE123C" : "#6B7280",
                          border: "1px solid",
                          borderColor: estadoDisplay === "RECIBIDA" ? "#FDBA74" : estadoDisplay === "APROBADA" ? "#86EFAC" : estadoDisplay === "RECHAZADA" ? "#FCA5A5" : "#D1D5DB",
                        }}>
                          {estadoDisplay === "RECIBIDA" && <MoveToInboxIcon sx={{ fontSize: 10 }} />}
                          {estadoDisplay === "APROBADA" && <TaskAltIcon sx={{ fontSize: 10 }} />}
                          {estadoDisplay === "RECHAZADA" && <CancelIcon sx={{ fontSize: 10 }} />}
                          {estadoDisplay}
                        </span>
                      </div>
                      <div className="traspaso-card-body">
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">RUT</span>
                          <span className="traspaso-card-value">{personaDNI}</span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">ID Origen</span>
                          <span style={{ backgroundColor: "#DBEAFE", color: "#1D4ED8", fontWeight: 700, fontSize: "12px", padding: "2px 8px", borderRadius: "6px", border: "1px solid #93C5FD" }}>
                            {procesoOrigen}
                          </span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">ID Destino</span>
                          <span className="traspaso-card-value">{procesoDestino}</span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">Solicitante</span>
                          <span className="traspaso-card-value">{solicitante}</span>
                        </div>
                        <div className="traspaso-card-row">
                          <span className="traspaso-card-label">Fecha</span>
                          <span className="traspaso-card-value">{formatDateToDDMMAAAA({ date: fechaSolicitud, format: "/" })}</span>
                        </div>
                      </div>
                      <div className="traspaso-card-footer">
                        <button
                          onClick={() => handleClickVerSolicitud(item)}
                          className="button-content"
                          disabled={loadingVerSolicitud === solicitudTraspasoId}
                        >
                          {loadingVerSolicitud === solicitudTraspasoId ? (
                            <CircularProgress size={18} thickness={4} sx={{ color: "#0065DD" }} />
                          ) : (
                            <VisibilityIcon sx={{ fontSize: 20, color: "#0065DD" }} />
                          )}
                        </button>
                        {isPendiente && (
                          <>
                            <button
                              className="button-content"
                              onClick={() => handleClickAcceptRegister({ personaDNI, solicitudTraspasoId })}
                            >
                              <IconCheck fill={"#06A502"} />
                            </button>
                            <button
                              className="button-content"
                              onClick={() => handleClickDeclineRegister({ personaDNI, solicitudTraspasoId })}
                            >
                              <IconCancel fill={"#FF4900"} />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              <FooterTablePagination
                offset={offset}
                setOffset={setOffset}
                paginationData={paginationData}
              />
            </>
          )}
        </>
      ) : (
        <TableSkeleton cols={9} />
      )}

      <AnimatePresence>
        {openModalVerSolicitud && detalleData && (
          <ModalVerSolicitud
            detalleData={detalleData}
            onClose={() => { setOpenModalVerSolicitud(false); setDetalleData(null); setCurrentViewingSolicitudId(null); }}
            onResponder={handleResponderDesdeDetalle}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isOpenModalAceptarRegistro && (
          <ModalAceptarRegistro
            rut={candidateSelect}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            onClose={() => setIsOpenModalAceptarRegistro(false)}
            onConfirm={() => {
              handleClickSolResponse({ status: true });
              setIsOpenModalAceptarRegistro(false);
            }}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isOpenModalRechazarRegistro && (
          <ModalRechazarRegistro
            rut={candidateSelect}
            solicitudes={solicitudes}
            setSolicitudes={setSolicitudes}
            onClose={() => setIsOpenModalRechazarRegistro(false)}
            onConfirm={() => {
              handleClickSolResponse({ status: false });
              setIsOpenModalRechazarRegistro(false);
            }}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default TablaSolicitudRecibida;
